import { StyleSheet } from "aphrodite/no-important";
import { colour } from "../style/base-theme";

export const styles = StyleSheet.create({
  subHeader: {
    display: "flex",
    justifyContent: "space-between",
  },
  subHeaderColumn: {
    flex: "1 0 0",
    alignItems: "center",
    display: "flex",
  },
  title: {
    textAlign: "center",
    fontSize: 18,
    fontWeight: 600,
    justifyContent: "center",
  },
  back: {
    display: "flex",
    background: "none",
    outline: "none",
    border: "none",
    cursor: "pointer",
    alignItems: "center",
    padding: "20px 10px 20px 0",
    textDecoration: "none",
    fontSize: "inherit",
    flex: 1,
    fontWeight: 600,
    color: colour.brand.blue,
    ":before": {
      fontFamily: "informetis",
      fontSize: 20,
      color: colour.brand.blue,
      content: '"\\E803"',
      paddingRight: 10,
      paddingTop: 1,
    },
  },
});
